import { createFileRoute, redirect } from '@tanstack/react-router'

/** Legacy Stripe return URL, one hop to the new one; the query string (`order_id`) travels along. */
export const Route = createFileRoute('/_shell/state-tax/cancel')({
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/state-filings/cancel', search, replace: true })
  },
})
